import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export default (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: 'row',
      backgroundColor: theme.colors.background,
    },
    // Styles pour la barre de recherche
    searchContainer: {
      paddingHorizontal: theme.spacing.lg,
      paddingBottom: theme.spacing.md,
      backgroundColor: theme.colors.white,
    },
    
    // Styles pour la section épinglée
    pinnedSection: {
      paddingVertical: theme.spacing.md,
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.green,
    },
    pinnedHeader: {
      paddingHorizontal: theme.spacing.lg,
      marginBottom: theme.spacing.sm,
    },
    pinnedButton: {
      alignItems: 'center',
      marginRight: theme.spacing.md,
      width: 60,
    },
    pinnedButtonContainer: {
      position: 'relative',
      width: 50,
      height: 50,
      borderRadius: 25,
      backgroundColor: theme.colors.grey,
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: theme.spacing.xs,
    },
    pinnedBadge: {
      position: 'absolute',
      top:0,
      right: 0,
      backgroundColor: theme.colors.error,
      borderRadius: 8,
      minWidth: 16,
      height: 16,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 4,
    },
    pinnedBadgeText: {
      color: theme.colors.white,
      fontWeight: 'bold',
      fontSize: 10,
    },
    pinnedButtonText: {
      textAlign: 'center',
      color: theme.colors.secondary,
    },
    pinnedText: {
      marginLeft: theme.spacing.xs,
      color: theme.colors.greyBlue,
    },
    pinnedList: {
      paddingHorizontal: theme.spacing.lg,
      overflow: 'hidden',
    },
    pinnedContact: {
      alignItems: 'center',
      marginRight: theme.spacing.md,
      width: 60,
    },
    pinnedAvatar: {
      width: 50,
      height: 50,
      borderRadius: 25,
      marginBottom: theme.spacing.xs,
    },
    pinnedGroupAvatar: {
      position: 'relative',
      width: 50,
      height: 50,
      marginBottom: theme.spacing.xs,
      backgroundColor: theme.colors.grey,
      borderRadius: 25,
      alignItems: 'center',
      justifyContent: 'center',
    },
    pinnedGroupAvatar1: {
      position: 'absolute',
      width: 22,
      height: 22,
      borderRadius: 11,
      left: 0,
      top: 14,
      borderWidth: 1,
      borderColor: theme.colors.white,
    },
    pinnedGroupAvatar2: {
      position: 'absolute',
      width: 30,
      height: 30,
      borderRadius: 15,
      left: 10,
      top: 10,
      borderWidth: 1,
      borderColor: theme.colors.white,
      zIndex: 1,
    },
    pinnedGroupAvatar3: {
      position: 'absolute',
      width: 22,
      height: 22,
      borderRadius: 11,
      right: 0,
      top: 14,
      borderWidth: 1,
      borderColor: theme.colors.white,
    },
    pinnedName: {
      textAlign: 'center',
      color: theme.colors.secondary,
    },
    
    searchContainerNonMobile: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing.lg,
    },
    searchContainerMobile: {
      marginBottom: theme.spacing.md,
    },
    // Styles pour les tabs
    tabContainer: {
      flexDirection: 'row',
      backgroundColor: theme.colors.white,
      paddingHorizontal: theme.spacing.lg,
    },
    tabButton: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 12,
      paddingVertical: theme.spacing.xs * 2,
      borderRadius: 20,
      borderWidth: 1,
      borderColor: theme.colors.lightGrey,
      marginRight: 8,
      backgroundColor: 'transparent',
    },
    tabIcon: {
      marginRight: theme.spacing.xs,
    },
    tabButtonText: {
      fontSize: 14,
      color: theme.colors.greyBlue,
    },
    // Styles pour la liste des messages
    messagesList: {
      flex: 1,
      backgroundColor: theme.colors.white,
    },
    messageItem: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.md,
      borderBottomWidth: 0.5,
      borderBottomColor: theme.colors.lightGrey,
    },
    
    // Styles pour l'avatar
    avatarContainer: {
      position: 'relative',
      marginRight: theme.spacing.md,
    },
    avatar: {
      width: 50,
      height: 50,
      borderRadius: 25,
      marginRight: theme.spacing.md,
    },
    groupAvatar1: {
      position: 'absolute',
      width: 26,
      height: 26,
      borderRadius: 13,
      left: 0,
      top: 12,
      borderWidth: 2,
      borderColor: theme.colors.white,
    },
    groupAvatar2: {
      position: 'absolute',
      width: 34,
      height: 34,
      borderRadius: 17,
      left: 8,
      top: 8,
      borderWidth: 2,
      borderColor: theme.colors.white,
      zIndex: 1,
    },
    groupAvatar3: {
      position: 'absolute',
      width: 26,
      height: 26,
      borderRadius: 13,
      right: 0,
      top: 12,
      borderWidth: 2,
      borderColor: theme.colors.white,
    },
    onlineIndicator: {
      position: 'absolute',
      bottom: 2,
      right: 2,
      width: 12,
      height: 12,
      borderRadius: 6,
      backgroundColor: theme.colors.green,
      borderWidth: 2,
      borderColor: theme.colors.white,
    },
    pinnedIndicator: {
      position: 'absolute',
      top: -5,
      right: -5,
      width: 20,
      height: 20,
      borderRadius: 10,
      backgroundColor: theme.colors.primary,
      alignItems: 'center',
      justifyContent: 'center',
    },
    
    // Styles pour le contenu du message
    messageContent: {
      flex: 1,
    },
    messageHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing.xs,
    },
    name: {
      flex: 1,
      color: theme.colors.secondary,
    },
    time: {
      color: theme.colors.greyBlue,
    },
    messageFooter: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    timeContainer: {
      alignItems: 'flex-end',
      marginTop: theme.spacing.xs,
    },
    lastMessage: {
      flex: 1,
      color: theme.colors.greyBlue,
    },
    unreadMessage: {
      color: theme.colors.secondary,
      fontWeight: '600',
    },
    unreadBadge: {
      backgroundColor: theme.colors.primary,
      borderRadius: 10,
      minWidth: 20,
      height: 20,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: theme.spacing.xs,
    },
    unreadText: {
      color: theme.colors.white,
      fontWeight: 'bold',
      fontSize: 11,
    },
  }) 